const clientSaleFullcont        = require('./clientSale-fullcont')
const clientSaleMT              = require('./clientSale-fullcont-multitable')
const clientSalePage            = require('./clientSale-page')
const clientSaleMenu            = require('./clientSale-menu')

export function start(detail){ 
      obj[detail.elem].start(detail)
}/**/

const obj = {
      fullcont:        { start: (detail)=>{  clientSaleFullcont. start(detail)        }},
      multitable:      { start: (detail)=>{  clientSaleMT.start(detail)               }},
      page:            { start: (detail)=>{  clientSalePage.start(detail)             }},
      menu:            { start: (detail)=>{  clientSaleMenu.start(detail)             }},
}

